import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { get_offers_by_company_id } from "../API/dataProvider";
import { Config } from "../config";
import { offersAtom } from "../Recoil/Atom";
import Loader from "./Loader";
import NoOfferCard from "./NoOfferCard";
import OfferCard from "./OfferCard";

function OffersByCategory({ item, setCount, index }) {
  const [offers, setOffers] = useState(false);
  const navigate = useNavigate();
  const setOffer = useSetRecoilState(offersAtom);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    get_offers_by_company_id(1, item.industry_id)
      .then((data) => {
        setOffers(data);
        if (setCount) {
          setCount((oldArray) => [...oldArray, index]);
        }
        data.data.forEach((item) => {
          if (setCount) {
            setOffer((oldOffer) => [...oldOffer, item.offer_id]);
          }
        });
      })
      .catch(() => {
        setOffers("");
      });
  }, []);

  const loadMore = () => {
    navigate(`${Config.brochure_route}`, { replace: true });
    setLoader(true);
    get_offers_by_company_id(offers.current_page + 1, item.industry_id)
      .then((data) => {
        setOffers((prev) => ({
          ...data,
          data: [...prev.data, ...data.data],
        }));
        setLoader(false);
      })
      .catch((e) => {
        setOffers("");
        setLoader(false);
      });
  };

  return (
    <div className="mb-12">
      <h2 className="text-xl lg:text-[26px] font-bold mb-2 lg:mb-6">
        {item.title}
      </h2>
      {offers === false ? (
        <Loader />
      ) : (
        <>
          <div
            id="brochure-grid"
            className="grid grid-cols-2 gap-4 mb-6 md:mb-10 sm:grid-cols-3 lg:grid-cols-4 md:gap-6 lg:gap-7"
          >
            {offers?.data?.length > 0 ? (
              offers?.data?.map((item, index) => {
                return <OfferCard key={index.toString()} item={item} />;
              })
            ) : (
              <div className="col-span-12">
                <NoOfferCard title={"Leider keine Prospekte gefunden"} />
              </div>
            )}
          </div>
          {offers?.current_page < offers?.last_page ? (
            <div className="text-center">
              <button
                className={`inline-flex items-center justify-center w-full max-w-sm px-4 py-2 text-xs text-dark transition-all duration-300 rounded-[3px] sm:text-sm hover:bg-primary hover:text-white border border-solid border-[#CBCDD0] font-semibold
                  ${loader ? "disabled:cursor-not-allowed" : ""}
                  `}
                onClick={() => loadMore()}
                disabled={loader}
              >
                {loader ? "Wird geladen..." : "Mehr anzeigen"}
              </button>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}

export default OffersByCategory;
